import FullTextReviewVote from '../FullTextReviewVote';
import FullTextReviewOutcome from '../FullTextReviewOutcome';
import BaseEventPayload from './BaseEventPayload';

export default class FullTextReviewEventPayload extends BaseEventPayload {
  constructor(data = {}, parentEventLog) {
    super(FullTextReviewEventPayload, data, parentEventLog);
    this.fullTextReviewState = data.fullTextReviewState;
    this.fullTextReviewVote =
      data.fullTextReviewVote &&
      new FullTextReviewVote(data.fullTextReviewVote);
    this.fullTextReviewOutcome =
      data.fullTextReviewOutcome &&
      new FullTextReviewOutcome(data.fullTextReviewOutcome);
  }
}
